<template>
    <div id="planes-sidebar-menu" class="sidebar-menu-container">
        <div class="sidebar-main-label">Создание плоскостей</div>
        <div class="sidebar-step-two-img-container planes-btn-grid">
            <div class="planes-btn-grid-element">
                <div class="planes-btn" v-on:click="createPlane('wall')">
                    <img class="planes-btn-img" :src="urlForStatic('/img/btn_walls.svg')"/>
                </div>
                <div class="planes-btn-text">Стены</div>
            </div>
            <div class="planes-btn-grid-element">
                <div class="planes-btn"  v-on:click="createPlane('window')">
                    <img class="planes-btn-img" :src="urlForStatic('/img/btn_window.svg')"/>
                </div>
                <div class="planes-btn-text">Оконные проёмы</div>
            </div>
            <div class="planes-btn-grid-element">
                <div class="planes-btn" v-on:click="createPlane('door')">
                    <img class="planes-btn-img" :src="urlForStatic('/img/btn_door.svg')"/>
                </div>
                <div class="planes-btn-text">Дверные проёмы</div>
            </div>
            <div class="planes-btn-grid-element">
                <div class="planes-btn" v-on:click="moveToPreAdditional()">
                    <img class="planes-btn-img" :src="urlForStatic('/img/btn_additions.svg')"/>
                </div>
                <div class="planes-btn-text">Доборные элементы</div>
            </div>
            <div class="planes-btn-grid-element">
                <div class="planes-btn" v-on:click="createPlane('cutout')">
                    <img class="planes-btn-img" :src="urlForStatic('/img/overlap.svg')"/>
                </div>
                <div class="planes-btn-text">Коррекция перекрытия</div>
            </div>
        </div>
        <div class="sidebar-text-area">Для точной и качественной визуализации дизайна необходимо определить плоскости различных зон вашего объекта:
            <span class="red-text bold-text">стены</span>, <span class="red-text bold-text">дверные</span> и <span class="red-text bold-text">оконные проемы</span>
            , а также зоны <span class="red-text bold-text">доборных элементов</span> и области, <span class="red-text bold-text">перекрываемые</span> объектами переднего плана.</div>
        <div class="sidebar-text-area">Чтобы перейти к созданию плоскости, выберите тип зоны, которую Вы собираетесь выделить в меню, расположенном выше.</div>
    </div>
</template>

<script>
    import {urlForStaticVue} from "../../common";
    import store from "../../../store";

    export default {
        name: "PlanesSidebarMenu",
        mixins: [urlForStaticVue],
        methods: {
            async createPlane(type) {
                const planeID = await store.dispatch(`active/ADD_PLANE`,
                    {
                        type: type,
                    })
                this.$router.push({
                    name: type,
                    params: {
                        planeID: planeID
                    },
                    query: this.$route.query
                }).catch(() => {});
            },
            moveToPreAdditional() {
              this.$router.push({
                name: "additional",
                params: {
                  planeID: 0
                },
                query: this.$route.query
              }).catch(() => {});
            }
        }
    }
</script>

<style scoped>
    @media screen and (max-height: 800px) {
        .planes-btn-grid {
            grid-column-gap: 5px;
        }

        .planes-btn-grid-element {
            width: 65px;
            height: auto;
            user-select: none;
        }

        .planes-btn {
            display: flex;
            background-color: #F2F2F2;
            justify-content: center;
            align-items: center;
            border-radius: 4px;
            height: 65px;
            cursor: pointer;
        }

        .planes-btn-img {
            max-width: 55px;
            max-height: 55px;
            width: 100%;
            height: 100%;
            box-sizing: border-box;
        }

        .planes-btn-text {
            display: block;
            text-align: center;
            margin: 5px 0;
            font-size: 12px;
        }
    }

    @media screen and (min-height: 800px) {
        .planes-btn-grid {
            grid-column-gap: 10px;
        }

        .planes-btn-grid-element {
            width: 90px;
            height: auto;
            user-select: none;
        }

        .planes-btn {
            display: flex;
            background-color: #F2F2F2;
            justify-content: center;
            align-items: center;
            border-radius: 4px;
            height: 90px;
            cursor: pointer;
        }

        .planes-btn-img {
            max-width: 70px;
            max-height: 70px;
            width: 100%;
            height: 100%;
            box-sizing: border-box;
        }

        .planes-btn-text {
            display: block;
            text-align: center;
            margin: 5px 0;
            font-size: 14px;
        }
    }

    .planes-btn-grid {
        display: grid;
        grid-template-columns: auto auto auto;
    }

    .planes-btn:hover {
        background-color: #E9E9E9;
        /*box-shadow: 0 7px 15px rgba(0, 0, 0, 0.05), 0 5px 30px rgba(0, 0, 0, 0.05), 0 12px 20px rgba(0, 0, 0, 0.05);*/
    }

    .planes-btn:active {
        background-color: #F2F2F2;
        /*box-shadow: none;*/
    }
</style>
